<div class="container-fluid px-0">
  <div class="d-flex justify-content-between mt-2">
    <h3 class="text-secondary">Recherche par :</h3>
    <button class="btn btn-primary" *appOnlyGroups="['ADMIN']" type="button" (click)="openModal()">Ajouter une structure</button>
  </div>
  <form [formGroup]="structureFilterFormGroup" (ngSubmit)="submitFilter()">
    <div class="row">
      <div class="text-secondary col-3">
        <label for="name">Nom</label>
        <input id="name" class="form-control" type="text" formControlName="name" />
      </div>
      <div class="text-secondary col-3">
        <label for="type">Statut</label>
        <select id="type" class="form-select" formControlName="status">
          <option [ngValue]="null"></option>
          <option [ngValue]="true">Active</option>
          <option [ngValue]="false">Inactive</option>
        </select>
      </div>
      <div class="text-secondary col-3">
        <label for="type">Numéro SIRET</label>
        <input
          id="name"
          class="form-control"
          type="text"
          formControlName="siret"
          [class.is-invalid]="structureFilterFormGroup.controls.siret.invalid"
        />
        <small *ngIf="structureFilterFormGroup.controls?.siret?.invalid" class="form-text text-danger">Taille maximale : 14</small>
      </div>
      <div class="text-secondary col-3">
        <label for="type">Public</label>
        <select id="type" class="form-select" formControlName="public">
          <option [ngValue]="null"></option>
          <option [ngValue]="true">Oui</option>
          <option [ngValue]="false">Non</option>
        </select>
      </div>
    </div>
    <div class="row mt-3">
      <div class="d-grid col-12 col-sm-12 col-xl-auto">
        <button type="submit" class="btn btn-primary">Rechercher</button>
      </div>
      <div class="d-grid col-12 col-sm-12 col-xl-auto ms-xl-1 mt-sm-2 mt-xl-0">
        <button type="button" class="btn btn-light" (click)="resetFilters()">Réinitialiser les filtres</button>
      </div>
    </div>
  </form>
  <div class="row mt-2">
    <div class="col">
      <table class="table table-sm table-striped table-hover" aria-describedby="structuresTitle">
        <thead class="text-secondary bg-light">
          <tr>
            <th></th>
            <th scope="col" class="text-center" sortable="idIODAS" (sort)="onSort($event)">Identifiant IODAS</th>
            <th scope="col" sortable="label" (sort)="onSort($event)">Nom</th>
            <th scope="col" sortable="SIRET" (sort)="onSort($event)">Numéro SIRET</th>
            <th scope="col" sortable="active" (sort)="onSort($event)">Statut</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let structure of filteredStructures">
            <td></td>
            <td (click)="openModal(structure.id)" class="text-center">{{ structure.idIODAS }}</td>
            <td (click)="openModal(structure.id)">{{ structure.label }}</td>
            <td (click)="openModal(structure.id)">{{ structure.SIRET | siret }}</td>
            <td (click)="openModal(structure.id)">{{ structure.active ? 'Active' : 'Inactive' }}</td>
          </tr>
        </tbody>
      </table>
      <p *ngIf="filteredStructures.length === 0">La recherche ne renvoie aucun résultat.</p>
    </div>
  </div>
</div>
